var map = {
	"./drive.png": "P41T",
	"./fundamentals.png": "sZIE",
	"./hello-hr.png": "rqfj",
	"./job-description-generator.png": "K+El",
	"./live-hr-advice.png": "dvSj",
	"./policy-manual-wizard.png": "emVL",
	"./surveys.png": "mPua",
	"./training.png": "Y0pS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pCVS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots ^\.\/.*\.png$
// module id = pCVS
// module chunks = 0